import { type ApiAuthStoreShape } from '@services/Auth/declarations'

export const authMock = {
  token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2OTcwMjk3ODcsImV4cCI6MTc2MDEwMTc4NywiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSJ9.isWLca_frlsTJlQnhE4GmgCD9uzSLd4Afn4Yxch8bqY',
  userIdentifier: 'user',
}

export const getClubByHashMock : ApiAuthStoreShape['postRefreshToken'] = {
  '@id': '/api/clubs/1',
  '@type': 'Club',
  token: '1234567890',
  refresh_token: '1234567890',
}
